module.exports = __webpack_public_path__ + "static/img/glyphicons-halflings-regular.8988968.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 273
// module chunks = 12